<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-container class="substantive-evaluation">
		<v-layout row>
			<v-btn @click="openOfferView" class="no-print">
				Podgląd oferty
			</v-btn>
			<v-menu offset-y open-on-hover v-if="viewData.volunteers.length > 0">
				<template v-slot:activator="{ on }">
					<v-btn class="no-print" v-on="on">
						Wolontariusze
					</v-btn>
				</template>
				<v-list>
					<v-list-tile v-for="(volunteer, index) in viewData.volunteers" v-bind:key="index"
						@click="showVolunteerProfile(volunteer.id)">
						<v-icon class="mr-2">account_circle</v-icon>
						{{volunteer.name}} {{volunteer.surname}}
					</v-list-tile>
				</v-list>
			</v-menu>
			<v-spacer></v-spacer>
			<v-btn @click="print" class="mr-3 no-print">Wydrukuj</v-btn>
		</v-layout>

		<v-card-title class="mt-3 mb-3">
			<div>
				<h2 class="mb-3">Opinia merytoryczna</h2>
				<div class="substantive-evaluation-card evaluation-font-size">
					<div>
						<strong class="mr-3">Nazwa oferenta:</strong> {{viewData.mainBidder}}
					</div>
					<div>
						<strong class="mr-3">Nazwa oferty:</strong> {{viewData.offerTitle}}
					</div>
					<div>
						<strong class="mr-3">Numer oferty:</strong> {{viewData.offerCode}}
					</div>
					<div>
						<strong class="mr-3">Suma kontrolna:</strong> {{viewData.controlSum}}
					</div>
					<div class="mt-3" v-if="viewData.donations.length === 1">
						<strong class="mr-3">Wnioskowana kwota:</strong> {{formatMoney(viewData.donations[0])}} PLN
					</div>
					<div class="mt-3" v-else>
						<strong class="mr-3">Wnioskowane kwoty</strong>
						<div class="ml-2" v-for="(donation, index) in viewData.donations" v-bind:key="index">
							<strong class="mr-3">Moduł {{index + 1}}:</strong> {{formatMoney(donation)}} PLN
						</div>
					</div>
					<div class="mt-3">
						<strong class="mr-3">Kraj:</strong> {{viewData.country}}
					</div>
					<div v-if="viewData.extraCountries.length > 0">
						<strong class="mr-3">Kraje dodatkowe:</strong> {{viewData.extraCountries.join(', ')}}
					</div>
					<div v-if="viewData.author">
						<strong class="mr-3">Autor:</strong> {{viewData.author}}
					</div>
					<div v-if="viewData.firstSendDate">
						<strong class="mr-3">Data pierwszego wysłania:</strong> {{viewData.firstSendDate}}
					</div>
					<div v-if="viewData.latestSendDate">
						<strong class="mr-3">Data ostatniego wysłania:</strong> {{viewData.latestSendDate}}
					</div>
				</div>
			</div>
		</v-card-title>

		<hr class="ma-4">

		<vue-form-generator
			name="generator"
			ref="vfg"
			:model="evaluationData.model"
			:options="formGenerator.formOptions"
			:schema="formGenerator.currentSchema"
			v-if="viewData.showGenerator">
		</vue-form-generator>

		<hr class="ma-4">

		<v-form ref="form" lazy-validation v-if="!configuration.booleanEvaluation" class="mb-5">
			<h3 class="mt-4 mb-4 ml-4">Ocena punktowa</h3>
			<div class="no-print">
				<v-container v-for="parameter in configuration.parameters" v-bind:key="parameter.id"
					class="text-xs-center ml-4">
					<v-layout row align-center>
						<v-flex xs4>
							<v-text-field
								browser-autocomplete="off"
								:data-vv-name="'param' + parameter.id"
								:data-vv-as="parameter.name"
								:error-messages="vErrors.collect('param' + parameter.id)"
								v-validate="{ numeric: true, required: true, between: [parameter.minRating, parameter.maxRating] }"
								:min="parameter.minRating"
								:max="parameter.maxRating"
								data-vv-validate-on="change"
								:name="parameter.id"
								type="number"
								:disabled="configuration.disabled"
								v-model="parameter.value"
								:hint="'Od '.concat(parameter.minRating).concat(' do ').concat(parameter.maxRating).concat(' pkt z mnożnikiem ').concat(parameter.multiplier)"
								:label="parameter.name" persistent-hint
								aria-label="label for evaluation">
							</v-text-field>
						</v-flex>
						<h3 class="ml-5"> Punkty: {{ (parameter.value * parameter.multiplier).toFixed(2) }} </h3>
					</v-layout>
				</v-container>
				<v-layout row align-center>
					<v-flex xs4/>
					<h3 class="mt-4">Suma punktów: {{sumOfPoints.toFixed(2)}}</h3>
				</v-layout>
			</div>
			<div class="d-none print-only ml-3 header-card-font-size">
				<v-container v-for="parameter in configuration.parameters" v-bind:key="parameter.id" class="ml-1">
					<v-layout row>
						<v-flex xs8 class="header-card-font-size text-xs-left">{{parameter.name +
							" (Od ".concat(parameter.minRating).concat(" do ").concat(parameter.maxRating)
								.concat(" pkt z mnożnikiem ").concat(parameter.multiplier) + "):"}}<strong
							class="header-card-font-size ml-4">{{parameter.value}}</strong></v-flex>
						<v-flex xs3 class="header-card-font-size text-xs-right">Punkty: <strong
							class="header-card-font-size ml-1">{{ (parameter.value * parameter.multiplier).toFixed(2) }}</strong>
						</v-flex>
					</v-layout>
				</v-container>
				<v-layout row mt-3 ml-1>
					<v-flex xs8 class="header-card-font-size text-xs-left"/>
					<v-flex xs3 class="text-xs-right"><strong class="header-card-font-size">Suma punktów:
						{{sumOfPoints.toFixed(2)}}</strong></v-flex>
				</v-layout>
			</div>
		</v-form>

		<v-form v-if="configuration.booleanEvaluation">
			<div style="page-break-inside: avoid">
				<h3 class="mt-4 mb-4 ml-4">Rekomendacja</h3>
				<v-container class="no-print">
					<v-layout row class="mb-4 substantive-evaluation-recommendation-outer">
						<v-flex xs1/>
						<v-flex xs10 :style="recommendationFrameStyle" class="substantive-evaluation-recommendation">
							<v-select
								class="ma-3"
								data-vv-name="recommending"
								data-vv-as="Rekomenduję ofertę"
								:error-messages="vErrors.collect('recommending')"
								v-validate="'required'"
								:items="viewData.selectItems"
								:disabled="configuration.disabled"
								item-text="name"
								item-value="value"
								v-model="evaluationData.recommending"
								label="Rekomenduję ofertę *"
								aria-label="recommendation"
								for="substantive-evaluation-form-reccomend-offer"
								id="substantive-evaluation-form-reccomend-offer"
							></v-select>
						</v-flex>
					</v-layout>
				</v-container>
				<div class="d-none print-only ml-3 header-card-font-size">
					Rekomenduję do dofinansowania: <strong
						class="ml-2 header-card-font-size">{{substantiveRecommendation}}</strong>
				</div>
			</div>
		</v-form>

		<div v-if="evaluationData.recommending || !configuration.booleanEvaluation">
			<div class="no-print">
				<hr class="ma-4">
				<h3 class="mt-4 mb-4 ml-4">Rekomendacja zmiany kwoty</h3>
				<template v-for="(item, index) in viewData.recommendedFoundings">
					<div :key="'founding-' + item.id">
						<h3 class="ma-2" v-if="viewData.recommendedFoundings.length > 1">Moduł {{index + 1}}</h3>
						<v-layout row align-center>
							<v-flex xs5>
								<v-subheader>{{item.recommendedFoundingSet ?
									"W kwocie zmienionej" :
									"W kwocie wnioskowanej (" + formatMoney(viewData.donations[index]) + " PLN)"}}
								</v-subheader>
							</v-flex>
							<v-switch
								:disabled="configuration.disabled"
								@change="switchd(item, index)"
								v-model="item.recommendedFoundingSet"
								aria-label="label for switch"
								class="no-print"
							></v-switch>
						</v-layout>
						<v-expand-transition>
							<div v-if="item.recommendedFoundingSet">
								<v-layout row align-center>
									<v-flex xs5>
										<div class="mb-2">
											<v-subheader>Rekomendowana kwota (PLN)</v-subheader>
										</div>
									</v-flex>
									<v-flex xs5>
										<egranty-number-input-field
											:data-vv-name="'founding-'+index"
											data-vv-as="Rekomendowana kwota"
											:error-messages="vErrors.collect('founding-'+index)"
											v-validate="'required'"
											label="Rekomendowana kwota"
											:disabled="configuration.disabled"
											type="number"
											suffix=" PLN"
											v-model="item.founding"
											aria-label="label for text"
										/>
									</v-flex>
								</v-layout>
								<v-layout style="page-break-inside: avoid">
									<v-textarea
										browser-autocomplete="off"
										outline
										auto-grow
										:data-vv-name="'foundingExplanation-'+index"
										data-vv-as="Uzasadnienie zmiany kwoty"
										label="Uzasadnienie zmiany kwoty"
										v-model="item.foundingExplanation"
										:error-messages="vErrors.collect('foundingExplanation-'+index)"
										v-validate="'required|min:10'"
										:disabled="configuration.disabled"
										class="no-print"
										aria-label="founding change explanation">
									</v-textarea>
									<div class="div-for-print">{{item.foundingExplanation}}</div>
								</v-layout>
							</div>
						</v-expand-transition>
					</div>
				</template>
			</div>
			<div class="d-none print-only">
				<hr class="ma-4">
				<h3 class="mt-4 mb-4 ml-4">Rekomendacja zmiany kwoty</h3>
				<template v-for="(item, index) in viewData.recommendedFoundings">
					<div :key="'founding-' + item.id" class="mt-3">
						<strong class="ma-2 header-card-font-size" v-if="viewData.recommendedFoundings.length > 1">Moduł
							{{index + 1}}</strong>
						<div class="mt-3 ml-3 header-card-font-size" v-if="item.recommendedFoundingSet">W kwocie
							zmienionej
						</div>
						<div class="mt-3 ml-3 header-card-font-size" v-else>
							W kwocie wnioskowanej: <strong class="ml-2 header-card-font-size">{{formatMoney(viewData.donations[index])
								+ " PLN"}}</strong>
						</div>
						<div class="mt-3 ml-3 header-card-font-size" v-if="item.recommendedFoundingSet">
							Rekomendowana kwota: <strong class="ml-2 header-card-font-size">{{formatMoney(item.founding)}}
								PLN</strong>
							<v-layout style="page-break-inside: avoid">
								<div class="mt-3 header-card-font-size">Uzasadnienie zmiany kwoty:
									<div class="div-for-print mt-3 header-card-font-size"
										style="color: black; width: 89vw">{{item.foundingExplanation}}
									</div>
								</div>
							</v-layout>
						</div>
					</div>
				</template>
			</div>
		</div>

		<v-btn @click="validateAndShowDialog" v-if="!configuration.disabled" color="success"
			class="no-print">
			<v-icon class="mr-2 white--text">send</v-icon>
			Wyślij
		</v-btn>

		<v-btn @click="saveEvaluation" v-if="!configuration.disabled" color="info" class="no-print">
			<v-icon class="mr-2 white--text">save</v-icon>
			Zapisz opinię
		</v-btn>

		<evaluation-confirmation-dialog :action="send" :dialog-model="viewData.sendEvaluationDialog"
			@close-confirmation="viewData.sendEvaluationDialog = false"
			action-label="Wyślij" content="Upewnij się, że wypełniłeś poprawnie formularz zanim zatwierdzisz opinię.
			Po zatwierdzeniu nie będzie możliwości edycji!" header="Wysyłka opinii" icon="send"/>
	</v-container>
</template>

<script>
	import {Api} from "@/api";
	import {genericFormUtil} from "@/utils/genericFormUtil";
	import Vue from "vue";
	import VueFormGenerator from "vue-form-generator";
	import {SubstantiveEvaluation} from "@/api/generated/SubstantiveEvaluation";
	import EvaluationConfirmationDialog from "../../EvaluationConfirmationDialog";
	import EgrantyNumberInputField from "../../../../../genericComponents/EgrantyNumberInputField";
	import {Numbers} from "@/utils/Numbers";
	import {Files} from "@/utils/Files";

	Vue.use(VueFormGenerator);

	export default {
		name: "SubstantiveEvaluation",
		components: {EgrantyNumberInputField, EvaluationConfirmationDialog},
		watch: {
			"evaluationData.model": {
				handler () {
					this.applyGenericForm(this.configuration.form);
				},
				deep: true,
			}
		},

		computed: {
			sumOfPoints () {
				let sum = 0;
				this.configuration.parameters.forEach(parameter => {
					if (parameter.value) {
            let part = parameter.value * parameter.multiplier;
						sum = sum + parseFloat(part.toFixed(2));
					}
				});
				return sum;
			},

			recommendationFrameStyle () {
				let color = this.evaluationData.recommending === true ? 'palegreen' :
					this.evaluationData.recommending === false ? 'palevioletred' : 'lightgray';
				return "border:2px solid " + color + "; border-radius: 25px;";
			},

			substantiveRecommendation () {
				let found = this.viewData.selectItems.find(item => item.value === this.evaluationData.recommending);
				if (!found) return "";
				return found.name;
			}
		},

		data () {
			return {
				configuration: {
					booleanEvaluation: false,
					form: "",
					parameters: [],
					disabled: false
				},

				evaluationData: {
					model: undefined,
					points: [],
					recommending: undefined,
				},

				viewData: {
					showGenerator: false,
					offerId: '',
					offerTitle: '',
					offerCode: '',
					controlSum: '',
					country: '',
					author: '',
          firstSendDate: '',
          latestSendDate: '',
					donations: [],
					extraCountries: [],
					recommendedFoundings: [],
					sendEvaluationDialog: false,
					volunteers: [],
					selectItems: [
						{
							name: "TAK", value: true,
						},
						{
							name: "NIE", value: false,
						},
					],
				},

				formGenerator: {
					currentSchema: {},
					currentModel: {},
					formOptions: {
						validateAfterLoad: false,
						validateAfterChanged: true,
						validateAsync: true,
					},
					currentConditionalHashes: []
				},

				validation: {},
			};
		},
		created () {
			this.loadData();
		},

		methods: {

			switchd(item, index) {
				if (!item.recommendationFoundingSet) {
					item.founding = this.viewData.donations[index];
				} else {
					item.founding = 0;
				}
			},

			async loadData () {
				await Api.syncGet(this, "/substantive-evaluation/configuration?contestId=".concat(this.$route.params.id), successResponse => {
					this.configuration.booleanEvaluation = successResponse.booleanEvaluation;
					this.configuration.form = genericFormUtil.decodeSchema(successResponse.form);
					this.configuration.parameters = successResponse.parameters;
				});

				SubstantiveEvaluation.get(this, this.$route.params.evaluationId, success => {
					if (success.filledForm === null) {
						this.evaluationData.model = genericFormUtil.buildModelFromSchema(this.configuration.form).sections[0].fields;
					} else {
						this.evaluationData.model = genericFormUtil.decodeSchema(success.filledForm);
					}
					this.viewData.offerId = success.offerId;
					this.viewData.offerTitle = success.title;
					this.viewData.offerCode = success.offerCode;
					this.viewData.controlSum = success.controlSum;
					this.viewData.author = success.nameSurname;
					this.viewData.country = success.country;
					this.viewData.extraCountries = [];
					this.viewData.volunteers = success.volunteers;
          this.viewData.firstSendDate = success.firstSendDate;
          this.viewData.latestSendDate = success.latestSendDate;
		 			this.viewData.mainBidder = success.mainBidder;
					this.viewData.recommendedFoundings = success.recommendedFoundings.sort(function (x, y) {
						return x.ordinalModuleNumber - y.ordinalModuleNumber;
					});
					success.extraCountries.forEach(country => {
						this.viewData.extraCountries.push(country);
					});
					this.evaluationData.extraCountries = success;
					while (this.viewData.donations.length) {
						this.viewData.donations.pop();
					}
					success.requestedDonations.forEach(donation => {
						this.viewData.donations.push(donation);
					});

					if (success.evaluationStatus === "FINISHED") {
						this.configuration.disabled = true;
					}
					this.applyGenericForm(this.configuration.form);
					this.evaluationData.points = success.substantiveEvaluationPoints;
					this.evaluationData.recommending = success.evaluationSet ? success.recommending : undefined;
					this.viewData.showGenerator = true;
					this.addValueToRatings();
				});
			},

			addValueToRatings () {
				for (let i = 0; i < this.configuration.parameters.length; i++) {
					let parameterId = this.configuration.parameters[i].id;
					let point = this.evaluationData.points.find(point => {
						return point.id.ratingParameterId === parameterId;
					});
					if (point && point.points) {
						this.$set(this.configuration.parameters[i], "value", parseInt(point.points, 10));
					} else {
						this.$set(this.configuration.parameters[i], "value", 0);
					}
				}
			},

			saveEvaluation () {
				SubstantiveEvaluation.putData(this, this.$route.params.evaluationId, this.prepareFormData(), successResponse => {
					this.$messagesBus.$emit("success", "Pomyślnie zapisano opinię", successResponse);
					this.loadData();
				}, errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się zapisać opinii", errorResponse);
				});
			},

			async send () {
				let validationPromise = await this.$refs.vfg.validate();
				if (validationPromise.length > 0) {
					this.$messagesBus.$emit("error", "Uzupełnij poprawnie dane formularza");
					return;
				}
				this.$validator.validateAll().then((result) => {
					if (result) {
						SubstantiveEvaluation.putFinish(this, this.$route.params.evaluationId, this.prepareFormData(), successResponse => {
							this.$messagesBus.$emit("success", "Opinia została wysłana", successResponse);
							this.$router.push("/app/evaluations/substantive");
						}, errorResponse => {
							this.viewData.sendEvaluationDialog = false;
							this.$messagesBus.$emit("error", "Nie udało się wysłać opinii", errorResponse);
						});
					} else {
						this.viewData.sendEvaluationDialog = false;
						this.$messagesBus.$emit("error", this.foundingsNotFilled() ?
							"Podaj kwotę rekomendowaną" : "Uzupełnij poprawnie dane opinii");
					}
				});
			},

			prepareFormData () {
				let points = {};
				this.configuration.parameters.forEach(parameter => {
					points[parseInt(parameter.id)] = parseInt(parameter.value) || 0;
				});
				return {
					evaluationSet: this.evaluationData.recommending !== undefined,
					recommending: this.evaluationData.recommending === undefined ? false : this.evaluationData.recommending,
					recommendedExplanation: this.viewData.foundingExplanation,
					recommendedFoundings: this.viewData.recommendedFoundings,
					filledForm: genericFormUtil.encodeSchema(this.evaluationData.model),
					points: points,
				};
			},

			applyGenericForm (form) {
				let schema = genericFormUtil.getSectionSchemaFromSchema(form, 0, this.configuration.disabled);
				if (genericFormUtil.sectionSchemaContainsConditionalField(schema)) {
					let schemaValues = this.evaluationData.model;
					this.formGenerator.currentSchema = genericFormUtil.filterSchemaByConditionalFieldsValue(schema, schemaValues);
					let indexes = genericFormUtil.calculateIndexes(schema);
					this.formGenerator.currentConditionalHashes = genericFormUtil.getConditionalValueHashes(schema, indexes);
				} else {
					this.formGenerator.currentSchema = schema;
				}
			},

			async validateAndShowDialog () {
				let validationPromise = await this.$refs.vfg.validate();
				if (validationPromise.length > 0) {
					this.$messagesBus.$emit("error", "Uzupełnij poprawnie dane formularza");
					return;
				}
				this.$validator.validateAll().then((result) => {
					if (!result) {
						this.$messagesBus.$emit("error", this.foundingsNotFilled() ?
							"Podaj kwotę rekomendowaną" : "Uzupełnij poprawnie dane opinii");
					} else {
						this.viewData.sendEvaluationDialog = true;
					}
				});
			},

			foundingsNotFilled () {
				let notFilled = false;
				this.viewData.recommendedFoundings.forEach(f => {
					if (f.recommendedFoundingSet && (f.founding === null || f.founding === "")) {
						notFilled = true;
					}
				});
				return notFilled;
			},

			showVolunteerProfile (volunteerId) {
				this.$router.openInNewTab({name: "profileView", params: {userId: volunteerId}});
			},

      openOfferView() {
        this.$router.openInNewTab('/view/contest/' + this.$route.params.id + '/offer/' + this.viewData.offerId);
      },

			async print () {
				await Files.methods.downloadFileAsBlob(
					this,
					Files.methods.getEvaluationPrintUrl(
						this.$route.params.id,
						this.$route.params.evaluationId,
						"substantive"
					),
					"opinia_indywidualna.pdf"
				);
			},
		},

		mixins: [
			Numbers
		]
	};
</script>

<style>
	.header-card-font-size {
		font-size: 14px;
	}

	@media print {
		.header-card-font-size {
			font-size: 13px;
		}

		.evaluation-font-size * {
			font-size: 13px;
		}
	}
</style>
